import { createReducer, on } from '@ngrx/store';
import * as DocumentFieldsActions from './documentfields.actions';
import { IMetadataItemDto } from '../metadata-item.dto';

export interface DocumentFieldsState {
  documentFields: IMetadataItemDto[];
  loading: boolean;
  error: string;
}

export const initialState: DocumentFieldsState = {
  documentFields: [],
  loading: false,
  error: null,
};

export interface ContactFieldsState {
  contactFields: IMetadataItemDto[]; // or appropriate type
  error?: string;
  loading?: boolean;
  stale?: boolean;
}

export const contactInitialState: ContactFieldsState = {
  contactFields: [],
  loading: false,
  error: null,
  stale: false
};


export const documentFieldsReducer = createReducer(
  initialState,

  on(DocumentFieldsActions.loadDocumentFields, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentFieldsActions.loadDocumentFieldsSuccess, (state, { documentFields }) => ({
    ...state,
    loading: false,
    documentFields,
  })),

  on(DocumentFieldsActions.loadDocumentFieldsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export const contactFieldsReducer = createReducer(
  contactInitialState,

  on(DocumentFieldsActions.loadContactFields, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentFieldsActions.loadContactFieldsSuccess, (state, { documentFields }) => ({
    ...state,
    loading: false,
    contactFields: documentFields,
    stale: false
  })),

  on(DocumentFieldsActions.loadContactFieldsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentFieldsActions.markContactFieldsStale, (state) => ({
    ...state,
    stale: true
  }))
);
